import "./styles.css";

import { AppProviders, RedirectCallback, SilentCallback } from "@orkestor/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

// OIDC landing pages MUST NOT boot the app: the sign-in redirect returns to
// `/acceso/callback` and the silent-renew iframe loads `/acceso/silent`, and
// mounting <AppProviders> on either would remount the auth provider — which
// itself starts another silent renew, nesting iframes until the renderer runs
// out of memory and the tab crashes ("This web page was reloaded because a
// problem occurred"). Handle them before any provider mounts: just complete the
// code exchange and move on, nothing else.
const path = window.location.pathname;
const app =
  path === "/acceso/callback" ? (
    <RedirectCallback />
  ) : path === "/acceso/silent" ? (
    <SilentCallback />
  ) : (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );

createRoot(root).render(<StrictMode>{app}</StrictMode>);
